import { Component, OnInit, Input } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';


@Component({
  selector: 'app-popup',
  templateUrl: './popup.page.html',
  styleUrls: ['./popup.page.scss'],
})
export class PopupPage implements OnInit {

  @Input() componentName: string;
  activeComponent: any;
  activeAmount: any;

  constructor(public modalController: ModalController,
    public navParams: NavParams) {
    this.activeComponent = navParams.get('componentName');
    this.activeAmount = navParams.get('activeAmount');
  }

  ngOnInit() {

  }

  /**
   * @mathod { Dismiss the popup }
   */
  closePopup() {
    this.modalController.dismiss();
  }


}
